<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">{{ $t('rooms') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">

      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{ $t('rooms') }}
          </h1>
          <p class="lead text-muted">
            {{ $t('rooms') }}
            {{ $t('ofProperty') }}
            {{property.name}}
          </p>
        </div>

      </header>
      <router-view id="list" :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rooms',
  data: () => ({
    title: '',
    property: ''
  }),
  created(){
    const slug = this.$route.params.property;
    this.property = this.$store.state.host.properties.find(p => p.slug == slug);
  }
};
</script>


<i18n>
{
  "en": {
    "rooms": "Rooms",
    "ofProperty": "of property"
  },
  "sl": {
    "rooms": "Sobe",
    "ofProperty": "nastanitve"
  }
}
</i18n>
